import { Component, OnInit } from '@angular/core'

@Component({
    selector: './achelous-description',
    templateUrl: './achelous-description.component.html',
    styleUrls: ['../../../../../help.component.css']
})

export class AchelousDescriptionComponent implements OnInit {

    ngOnInit() {

    }
}